<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <fiveLevel @upFive="upFive" :sproject="project" :scommunity="community"/>
                </div>
                <el-button type="primary" @click="hanldSearch">搜索</el-button>
            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                </div>
            </div>

            <el-table
                :data="residentList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
                <el-table-column label="楼门户" >
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.building_name }}-{{scope.row.element_name}}-{{scope.row.room_name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" prop="guanjia_name"></el-table-column>
<!--                <el-table-column label="居民姓名" prop="name"></el-table-column>-->
<!--                <el-table-column label="手机号" prop="phone"></el-table-column>-->

                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="danger"
                                @click="showItem(scope.row.id)">查看
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="residentList.length > 0"
                class="page-all"
                background
                @current-change="getResidentList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import fiveLevel from '@/components/five-level'
import {roomDevList} from "@/api/houst";

export default {
    name: "service-safety",
    data() {
        return {
            project: 0,
            community: 0,
            building: 0,
            unit: 0,
            room: 0,
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
            setId: 0,
            setItem: null,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "安全守护", false);
        this.roomDevList()
    },
    components: {
        fiveLevel,
    },
    methods: {
        //  查看
        showItem(id){
            this.$router.push(`/home/safety-dev-detail/${id}`)
        },

        //  搜索
        hanldSearch() {
            this.page = 1
            this.roomDevList()
        },

        //  获取居民列表
        async roomDevList() {
            let _data = await roomDevList(
                this.project,
                this.community,
                this.building,
                this.unit,
                this.room,
                this.page,
                this.limit,
            )
            if(_data.status === 200){
                this.residentList = _data.data
                this.total = _data.total_number
            }else{
                this.$message.error(_data.info)
                this.residentList = []
                this.total = 0
            }

        },
        //  同步更新五级联动
        upFive(val) {
            this.project = val.project
            this.community = val.community
            this.building = val.building
            this.unit = val.unit
            this.room = val.room
        }
    },
    filters: {
    },
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
